import React, { useState, useContext, useEffect } from 'react';
import {
    Modal, ModalHeader, ModalBody, Form, FormGroup, Label,
    Input, Button, Row, Col
} from 'reactstrap';
import InputMask from 'react-input-mask';
import { ResponsavelContext } from '../../context/ResponsavelContext';
import { AuthContext } from '../../context/AuthContext';
import { CreateResponsavelType } from '../../context/hooks/useResponsavel';

interface Props {
    isOpen: boolean;
    toggle: () => void;
    instituicaoId: number;
    onResponsavelCriado: () => void;
}

export const CreateResponsavelModal: React.FC<Props> = ({ isOpen, toggle, instituicaoId, onResponsavelCriado }) => {
    const { createResponsavel } = useContext(ResponsavelContext);
    const { objUserTk } = useContext(AuthContext);

    const [formData, setFormData] = useState<CreateResponsavelType>({
        name: '',
        email: '',
        CPF: '',
        telephone: '',
        position: '',
        bank: '',
        agency: '',
        currentAccount: '',
        observation: '',
        pix: '',
        idEmpresa: objUserTk?.EmpresaId || 0,
        idInstituicao: instituicaoId
    });

    useEffect(() => {
        if (isOpen) {
            setFormData({
                name: '',
                email: '',
                CPF: '',
                telephone: '',
                position: '',
                bank: '',
                agency: '',
                currentAccount: '',
                observation: '',
                pix: '',
                idEmpresa: objUserTk?.EmpresaId || 0,
                idInstituicao: instituicaoId
            });
        }
    }, [isOpen, instituicaoId]);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        try {
            const created = await createResponsavel(formData);
            if (created) {
                onResponsavelCriado();
                toggle();
            } else {
                console.error("Erro ao criar responsável.");
            }
        } catch (err) {
            console.error("Erro ao criar responsável:", err);
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} backdrop="static" size="lg">
            <ModalHeader toggle={toggle}>Adicionar novo responsável</ModalHeader>
            <ModalBody>
                <Form onSubmit={handleSubmit}>
                    <Row>
                        <Col md="12">
                            <FormGroup>
                                <Label className="form-control-label">Nome</Label>
                                <Input
                                    className="form-control-alternative"
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleInputChange}
                                    placeholder="Nome completo"
                                    required
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label className="form-control-label">Email</Label>
                                <Input
                                    className="form-control-alternative"
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                    placeholder="Email"
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label className="form-control-label">CPF</Label>
                                <InputMask
                                    className="form-control form-control-alternative"
                                    mask="999.999.999-99"
                                    name="CPF"
                                    value={formData.CPF}
                                    onChange={handleInputChange}
                                    placeholder="000.000.000-00"
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label className="form-control-label">Telefone</Label>
                                <InputMask
                                    className="form-control form-control-alternative"
                                    mask="(99) 99999-9999"
                                    name="telephone"
                                    value={formData.telephone}
                                    onChange={handleInputChange}
                                    placeholder="(00) 00000-0000"
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label className="form-control-label">Cargo</Label>
                                <Input
                                    className="form-control-alternative"
                                    name="position"
                                    value={formData.position}
                                    onChange={handleInputChange}
                                    placeholder="Cargo do responsável"
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col md="3">
                            <FormGroup>
                                <Label className="form-control-label">Banco</Label>
                                <Input
                                    className="form-control-alternative"
                                    name="bank"
                                    value={formData.bank}
                                    onChange={handleInputChange}
                                    placeholder="Nome do banco"
                                />
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label className="form-control-label">Agência</Label>
                                <InputMask
                                    className="form-control form-control-alternative"
                                    mask="9999"
                                    name="agency"
                                    value={formData.agency}
                                    onChange={handleInputChange}
                                    placeholder="0000"
                                />
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label className="form-control-label">Conta</Label>
                                <InputMask
                                    className="form-control form-control-alternative"
                                    mask="999999-9"
                                    name="currentAccount"
                                    value={formData.currentAccount}
                                    onChange={handleInputChange}
                                    placeholder="000000-0"
                                />
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label className="form-control-label">Chave Pix</Label>
                                <Input
                                    className="form-control-alternative"
                                    name="pix"
                                    value={formData.pix}
                                    onChange={handleInputChange}
                                    placeholder="Chave Pix"
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col md="12">
                            <FormGroup>
                                <Label className="form-control-label">Observação</Label>
                                <Input
                                    className="form-control-alternative"
                                    type="textarea"
                                    name="observation"
                                    value={formData.observation}
                                    onChange={handleInputChange}
                                    placeholder="Observação"
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <div className="d-flex justify-content-end mt-4">
                        <Button style={{ color: "#FFF", backgroundColor: "#585858" }} type="submit">Criar responsável</Button>
                        <Button style={{ color: "#FFF", backgroundColor: "#d9534f" }} className="ml-2" onClick={toggle}>Cancelar</Button>
                    </div>
                </Form>
            </ModalBody>
        </Modal>
    );
};

export default CreateResponsavelModal;